import { z } from "zod";
export const eventTypeSchema = z.enum([
    "event",
    "deadline",
    "milestone",
    "reminder",
]);
export const calendarEventInputSchema = z.object({
    userId: z.string().min(1),
    title: z.string().min(1).max(500),
    startTime: z.string().min(1),
    endTime: z.string().optional(),
    eventType: eventTypeSchema.default("event"),
    description: z.string().max(5000).optional(),
    location: z.string().max(500).optional(),
    allDay: z.boolean().default(false),
    linkedTaskId: z.string().optional(),
    recurring: z.boolean().default(false),
    recurrenceRule: z.string().optional(),
});
export const calendarEventSchema = calendarEventInputSchema.extend({
    id: z.string().min(1),
    createdAt: z.string().min(1),
    updatedAt: z.string().min(1),
});
//# sourceMappingURL=calendar.js.map